// extracted by mini-css-extract-plugin
export default {"label":"styles_label__dxMdO","assignedTo":"styles_assignedTo__dfUV1"};